import Text from "@/components/common/Text"
import SinglePartner from "@/components/TilesModule/variants/WhoHelpsTilesModule/SinglePartner"
import { StyledTileIndicator } from "@/components/TilesModule/variants/WhoHelpsTilesModule/index"
import GridContainer from "@/components/common/GridContainer"
import styled from "styled-components"
import { WHO_HELPS_VARIANTS } from "@/constants"
import { isStringEmpty } from "@/utils/utils"

const StyledGridContainer = styled(GridContainer)`
	position: relative;

	&.variant-${WHO_HELPS_VARIANTS.TWO_TEAM_MEMBERS}, &.variant-${WHO_HELPS_VARIANTS.DEFAULT} &:not(.ltf) {
		direction: rtl;
	}
`

export default function Partners({ partners = [], partnerTitle, variant }) {
	const colsDesktop = variant === WHO_HELPS_VARIANTS.MANY ? 16 : 8
	const rtlDirection = partners.length > 2

	return (
		<>
			<StyledGridContainer
				className={`col-mobile-8 col-tablet-8 col-desktop-${colsDesktop} no-margin variant-${variant} ${rtlDirection ? "rtl" : "ltf"}`}
			>
				{!isStringEmpty(partnerTitle) && (
					<StyledTileIndicator>
						<Text className="square static">{partnerTitle}</Text>
					</StyledTileIndicator>
				)}
				{partners.map((partner, index) => {
					const id = partner?.id || index
					return <SinglePartner key={id} partner={partner} variant={variant} />
				})}
			</StyledGridContainer>
		</>
	)
}
